(function (Cobalt) {
    var PrivateMessage = /** @class */ (function () {
        function PrivateMessage() {
        }
        PrivateMessage.initialize = function () {
            $("#field-recipients,#field-bcc").each(function () {
                var delimiter = $(this).attr("data-delimiter");
                if (delimiter) {
                    delimiter = delimiter + " ";
                }
                else {
                    delimiter = ", ";
                }
                $(this).autocomplete(Cobalt.Routes.Instance.PrivateMessageAjaxAutoCompleteContact(), "Auto-Complete-Contact", {
                    multiple: true,
                    multipleSeparator: delimiter,
                    scroll: false,
                    dataType: 'json',
                    parse: function (data) {
                        var result = [];
                        for (var i = 0; i < data.length; i++) {
                            var row = data[i];
                            if (row.Type == "role") {
                                var values = "";
                                var delimit = this.multipleSeparator;
                                $.each(row.Values, function (index, item) {
                                    values += item;
                                    if (index !== row.Values.length - 1) {
                                        values += delimit;
                                    }
                                });
                                result.push({ data: row, value: row.Name, result: values });
                            }
                            else {
                                result.push({ data: row, value: row.Username, result: row.Username });
                            }
                        }
                        return result;
                    },
                    formatItem: function (row) {
                        var div = $("<div>").addClass("character-autocomplete-result-row");
                        var img;
                        if (row.Avatar != null) {
                            img = $("<img>").attr("src", row.Avatar);
                            div.append(img);
                            div.addClass("with-avatar");
                        }
                        else if (row.GameAvatarSmall != null || row.GameName != null) {
                            img = $("<img>").attr("src", row.GameAvatarSmall).attr("alt", row.GameName);
                            div.append(img);
                        }
                        if (row.Type == "role") {
                            div.append(row.Name + " ");
                        }
                        else {
                            div.append(row.Username + " ");
                        }
                        return $("<div>").append(div).html();
                    }
                });
            });
            $(".send-pm #field-submit").text("Send Message");
            this.handleMoveToFolder();
            this.handleDeleteFolder();
            $("#field-preview-submit").hide();
            var moveToFolders = $("#form-field-pm-folder");
            moveToFolders.hide();
            $(".j-bulk-moderation").on("change", "#field-action", function () {
                if ($(this).val() === "4") {
                    moveToFolders.show();
                }
                else {
                    moveToFolders.hide();
                }
            });
            $("#field-pm-folder option:first").val("0"); //Set 'Inbox' to 0 to bypass js validation
            // ConversationHistory
            if (Cobalt.PrivateMessage.conversationHistory) {
                $.each(Cobalt.PrivateMessage.conversationHistory, function () {
                    var wrapper = $("[data-after-comment='" + this.AfterCommentID + "']");
                    var afterComment = $(".j-comment[data-id=" + this.AfterCommentID + "]");
                    if (afterComment.parent().find($("[data-after-comment='" + this.AfterCommentID + "']")).length < 1) {
                        wrapper = $("<div>").attr("data-after-comment", this.AfterCommentID);
                        wrapper.insertAfter(afterComment);
                    }
                    wrapper.append($("#comment-history-template").tmpl(this));
                });
            }
        };
        PrivateMessage.handleMoveToFolder = function () {
            $(".p-pm-move-to").on("click", ".j-folder-select", function (e) {
                e.preventDefault();
                var conversationID = $(this).attr("data-conversation-id");
                var folderID = $(this).attr("data-folder-id");
                var requestVerificationToken = $.cookie("RequestVerificationToken");
                if (requestVerificationToken) {
                    Cobalt.PrivateMessage.moveToFolder(conversationID, folderID, requestVerificationToken);
                }
                else {
                    $.ajax({
                        url: "/refresh-request-verification-token",
                        type: 'POST',
                        dataType: 'json',
                        success: function (data) {
                            Cobalt.PrivateMessage.moveToFolder(conversationID, folderID, $.cookie("RequestVerificationToken"));
                        }
                    });
                }
            });
        };
        PrivateMessage.moveToFolder = function (conversationID, folderID, requestVerificationToken) {
            $.ajax({
                url: Cobalt.Routes.Instance.PrivateMessageMoveToConversationFolder(conversationID, folderID),
                type: 'POST',
                data: {
                    'request-verification-token': requestVerificationToken,
                },
                success: function (data) {
                    if (data.success) {
                        $(".p-pm-a .j-pm-folder").empty();
                        $(".p-pm-a .j-pm-folder").append("<a href=\"" + Cobalt.Routes.Instance.PrivateMessageIndex() + "?view=folder&folder-id=" + data.folderID + "\">[" + data.folder + "]</a>");
                    }
                }
            });
        };
        PrivateMessage.handleDeleteFolder = function () {
            $("li.j-folder-delete").each(function () {
                if (!$(this).hasClass('hasDelete')) {
                    if ($(this).hasClass("selected")) {
                        $(this).append("<span class=\"remove-link j-pm-folder-delete\"></span>");
                    }
                    else {
                        $(this).hover(function () {
                            $(this).append("<span class=\"remove-link j-pm-folder-delete\"></span>");
                        }, function () { $(this).find("span.remove-link:last").remove(); });
                    }
                    $(this).addClass('hasDelete');
                }
            });
            $("body").on("click", ".j-pm-folder-delete", function (e) {
                e.preventDefault();
                e.stopPropagation();
                var folderID = $(this).parent().attr("data-folder-id");
                if (confirm("Are you sure you want to remove this folder?  All private messages in this folder will be moved to inbox.")) {
                    var requestVerificationToken = $.cookie("RequestVerificationToken");
                    if (requestVerificationToken) {
                        Cobalt.PrivateMessage.deleteFolder(folderID, requestVerificationToken);
                    }
                    else {
                        $.ajax({
                            url: "/refresh-request-verification-token",
                            type: 'POST',
                            dataType: 'json',
                            success: function (data) {
                                Cobalt.PrivateMessage.deleteFolder(folderID, $.cookie("RequestVerificationToken"));
                            }
                        });
                    }
                }
            });
        };
        PrivateMessage.deleteFolder = function (folderID, requestVerificationToken) {
            $.ajax({
                url: Cobalt.Routes.Instance.PrivateMessageDeleteConversationFolder(folderID),
                type: 'POST',
                data: {
                    'request-verification-token': requestVerificationToken,
                },
                success: function (data) {
                    if (data.success) {
                        self.location.href = data.returnUrl;
                    }
                    else {
                        alert("An unexpected error occurred");
                    }
                }
            });
        };
        return PrivateMessage;
    }());
    Cobalt.PrivateMessage = PrivateMessage;
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.PrivateMessage.js